var map = {
	"./audit-trail-and-records-history.png": 6933,
	"./automated-notifications.png": 1582,
	"./backup-scheduling.png": 5020,
	"./blank-profile.png": 8651,
	"./budgets.png": 5700,
	"./cancel-anytime.png": 6483,
	"./cancelled.png": 3244,
	"./customizable-reporting.png": 5086,
	"./dashboards-and-analytics.png": 2386,
	"./degital-storage.png": 8858,
	"./document-center.png": 1869,
	"./email-invoice-sending.png": 5615,
	"./financial-clarifications.png": 2017,
	"./financial-statement-designer.png": 5038,
	"./fixed-assets.png": 8738,
	"./general-ledger.png": 1508,
	"./instant-access.png": 1897,
	"./introduction.png": 8642,
	"./inventory.png": 2632,
	"./logo.png": 6949,
	"./mail_sent.png": 5664,
	"./payables.png": 1710,
	"./permissions.png": 9039,
	"./print-designer.png": 3013,
	"./purchases.png": 1443,
	"./receivables.png": 5129,
	"./report-designer.png": 2621,
	"./sales.png": 6286,
	"./secure-payments.png": 4405,
	"./support.png": 6145,
	"./taxes.png": 1526,
	"./verified.png": 8271
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;